import React from 'react';
import { AnimatePresence, motion, useScroll, useSpring } from 'framer-motion';
import { Plus } from 'lucide-react';
import { useAccent } from './AccentContext';
import { EASE_EXPO } from './ease';

/**
 * 画面左端の固定レール: セクションカウンター（数字ロール）+
 * スクロール進捗ライン + クロスヘア。コンセプトの "01 / 05" 意匠。
 */
export default function Rail() {
  const { active } = useAccent();
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });

  if (!active.total) return null;
  const num = String(active.index + 1).padStart(2, '0');
  const total = String(active.total).padStart(2, '0');

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-y-0 left-0 z-40 hidden w-14 flex-col items-center justify-between border-r border-line/50 pb-8 pt-28 xl:flex"
    >
      <div className="flex flex-col items-center gap-1 text-[11px] font-semibold tracking-label text-gray-500 tnum">
        <span className="block h-[15px] overflow-hidden leading-[15px]">
          <AnimatePresence mode="popLayout" initial={false}>
            <motion.span
              key={num}
              className="block text-live"
              initial={{ y: '110%' }}
              animate={{ y: '0%' }}
              exit={{ y: '-110%' }}
              transition={{ duration: 0.5, ease: EASE_EXPO }}
            >
              {num}
            </motion.span>
          </AnimatePresence>
        </span>
        <span className="h-px w-4 rotate-[-55deg] bg-line" />
        <span>{total}</span>
      </div>

      <div className="relative my-6 w-px flex-1 overflow-hidden bg-line/70">
        <motion.span
          className="absolute inset-0 origin-top bg-live"
          style={{ scaleY: progress }}
        />
      </div>

      <Plus size={15} strokeWidth={1} className="text-gray-400" />
    </div>
  );
}
